import { execute } from "@/utils/database_module";
import { DataRow, Product, User } from "@/utils/types";
import moment from "moment";
import "moment/locale/fr";
import {
  AWAITING_QUOTE_STATUS,
  QUOTE_ISSUED_STATUS,
  AWAITING_PAYMENT_STATUS,
  AWAITING_CONFIRMATION_STATUS,
  PAYMENT_FAILED,
  AWAITING_SHIPPING_STATUS,
  DELIVERED_PAID_STATUS,
  CANCELED_STATUS,
  IN_DELEVERY_STATUS,
  DELEVERED_STATUS,
  READY_TO_SHIP_STATUS,
  PENDING_RECEIPT_STATUS,


} from "@/utils/utilLists";





const stats = {


    getKPI : async ({ startDate , endDate , is_order_special } : { startDate? : string , endDate? : string , is_order_special? :boolean }) => {
      const orderstartDateStr = startDate  ? ` AND DATE(orders.date) >= '${moment(startDate).format("YYYY-MM-DD")}' `  : "";
        const orderendDateStr = endDate  ? ` AND DATE(orders.date) <= '${moment(endDate).format("YYYY-MM-DD")}' `  : "";
        const specialOrderStr = is_order_special ? ` AND orders.is_special=1`: ""
    
        let salesQuery = `SELECT SUM(total_price) AS total , date FROM orders WHERE status = ${DELIVERED_PAID_STATUS}  OR status = ${DELEVERED_STATUS} ${specialOrderStr} ${orderstartDateStr} ${orderendDateStr} `;
        const [salesResult] = (await execute(salesQuery)) as Record<string, number>[];
        const salesTotal = salesResult["total"] || 0;

        let paidOrdersQuery = `SELECT COUNT(id) FROM orders WHERE status <> ${CANCELED_STATUS} ${specialOrderStr} ${orderstartDateStr} ${orderendDateStr} `;
        const [paidOrdersResult] = (await execute(paidOrdersQuery)) as Record<string,number>[];
        const paidOrdersTotal = paidOrdersResult["COUNT(id)"] || 0;
    
        let ordersQuery = `SELECT COUNT(id) FROM orders WHERE 1=1 ${specialOrderStr} `;
        const [ordersResult] = (await execute(ordersQuery)) as Record<string,number>[];
        const ordersTotal = ordersResult["COUNT(id)"] || 0;
    
        let cancelledOrdersQuery = `SELECT COUNT(id) FROM orders WHERE status = ${CANCELED_STATUS}  ${specialOrderStr} ${orderstartDateStr} ${orderendDateStr}  `;
        const [cancelledOrdersResult] = (await execute(cancelledOrdersQuery)) as Record<string, number>[];
        const cancelledOrdersTotal = cancelledOrdersResult["COUNT(id)"] || 0;

        const usersstartDateStr = startDate  ? ` AND users.date >= '${moment(startDate).format("YYYY-MM-DD")}' `  : "";
        const usersendDateStr = endDate  ? ` AND users.date <= '${moment(endDate).format("YYYY-MM-DD")}' `  : "";
     
        let usersQuery = `SELECT COUNT(id) FROM users WHERE role = "user"  ${usersstartDateStr} ${usersendDateStr} `;
        const [usersResult] = (await execute(usersQuery)) as Record<string, number>[];
        const usersTotal = usersResult["COUNT(id)"] || 0;

        const productsstartDateStr = startDate ? ` AND DATE(products.date) >= '${moment(startDate).format("YYYY-MM-DD")}' ` : "";
        const productsendDateStr = endDate  ? ` AND DATE(products.date) <= '${moment(endDate).format("YYYY-MM-DD")}' `  : "";

        let productsQuery = `SELECT COUNT(id) FROM products WHERE is_deleted = 0  ${productsstartDateStr} ${productsendDateStr}  `;
        const [productsResult] = (await execute(productsQuery))as any[];
        const productsTotal = productsResult["COUNT(id)"] || 0;
       
        const carsstartDateStr = startDate ? ` AND DATE(cars.date) >= '${moment(startDate).format("YYYY-MM-DD")}' ` : "";
        const carsendDateStr = endDate  ? ` AND DATE(cars.date) <= '${moment(endDate).format("YYYY-MM-DD")}' `  : "";
        let carsQuery = `SELECT COUNT(id) FROM cars WHERE is_deleted = 0  ${carsstartDateStr} ${carsendDateStr}  `;
        const [carssResult] = (await execute(carsQuery))as any[];
        const carsTotal = carssResult["COUNT(id)"] || 0;

        const stats = {
            salesTotal,
            ordersTotal,
            paidOrdersTotal,
            cancelledOrdersTotal,
            usersTotal,
            productsTotal,
            carsTotal
        };

        return stats;
    },

    getOrdersStats  : async ( { startDate , endDate , is_order_special } : { startDate? : string , endDate? : string , is_order_special? :boolean }) => {
       
        const orderstartDateStr = startDate  ? ` AND DATE(orders.date) >= '${moment(startDate).format("YYYY-MM-DD")}' `  : "";
        const orderendDateStr = endDate  ? ` AND DATE(orders.date) <= '${moment(endDate).format("YYYY-MM-DD")}' `  : "";
        const specialOrderStr = is_order_special ? ` AND orders.is_special=1`: ""
    
      
        let ordersStatusQuery = `SELECT COUNT(orders.id) as data , order_status.name as label , order_status.color as status_color FROM orders join order_status ON orders.status = order_status.id  ${orderstartDateStr} ${specialOrderStr} ${orderendDateStr}  GROUP BY orders.status  `;
        const ordersStatus = await execute(ordersStatusQuery) as DataRow[] ;
    
        let ordersByCategoryQuery = `SELECT c.id AS category_id, c.name AS label, c.background_color  AS color, COUNT(orders.id) AS data FROM orders  JOIN products ON orders.product_id = products.id JOIN categories c ON products.category_id = c.id  WHERE orders.is_deleted = 0 GROUP BY c.id ORDER BY data DESC   `;
        const ordersByCategory = await execute(ordersByCategoryQuery) as DataRow[];
        for (const iterator of ordersByCategory) {
          iterator.label= typeof iterator.label == "string" ? JSON.parse(`${iterator.label}`) : iterator.label
        }

        
        let ordersBySuperCategoryQuery = `SELECT sc.id AS super_category_id, sc.name AS label, sc.background_color  AS color, COUNT(orders.id) AS data FROM orders JOIN products ON orders.product_id = products.id JOIN super_categories sc ON products.super_category_id = sc.id WHERE orders.is_deleted = 0 GROUP BY sc.id ORDER BY data DESC    ` ;
        const ordersBySuperCategory = await execute(ordersBySuperCategoryQuery) as DataRow[];
        for (const iterator of ordersBySuperCategory) {
          iterator.label= typeof iterator.label == "string" ? JSON.parse(`${iterator.label}`) : iterator.label
    
        }

        
      let bestSellersQuery = `SELECT products.name  as label, products.id ,  products.images, COUNT(orders.product_id) AS data FROM products JOIN orders ON products.id = orders.product_id WHERE products.is_deleted = 0  ${specialOrderStr}   ${orderstartDateStr} ${orderendDateStr} GROUP BY orders.product_id ORDER BY data DESC LIMIT 5`;
      const bestSellers = (await execute(bestSellersQuery)) as (Product & {label : string })[] | DataRow[];
      for (const bestSeller of bestSellers as (Product & {label : string })[]) {        
        bestSeller.label= typeof bestSeller.label == "string" ? JSON.parse(`${bestSeller.label}`) : bestSeller.label
        bestSeller.images = typeof bestSeller.images== 'string' ?JSON.parse(`${bestSeller.images}`) : bestSeller.images
        
      }   

        let ordersBysubCategoryQuery = `SELECT sc.id AS sub_category_id, sc.name AS label,sc.background_color  AS color, COUNT(orders.id) AS data FROM orders  JOIN products ON orders.product_id = products.id JOIN sub_categories sc ON products.sub_category_id = sc.id  WHERE orders.is_deleted = 0 GROUP BY sc.id ORDER BY data DESC`;
        const ordersBySubCategory = await execute(ordersBysubCategoryQuery) as DataRow[];
        for (const iterator of ordersBySubCategory) {
          iterator.label= typeof iterator.label == "string" ? JSON.parse(`${iterator.label}`) : iterator.label
    
        }
    
        let salesChartQuery = `SELECT SUM(total_price) as data, date as label FROM orders WHERE orders.status=${DELIVERED_PAID_STATUS} OR status = ${CANCELED_STATUS} ${specialOrderStr} ${orderstartDateStr} ${orderendDateStr}  GROUP BY date ORDER BY date `;
        const salesChart = await execute(salesChartQuery) as DataRow[];


        const stats = {
            salesChart,
            ordersBySuperCategory,
            ordersBySubCategory ,
            ordersByCategory,
            ordersStatus,
            bestSellers
        }
        return stats
    },


    getUsersStats  : async ( { startDate , endDate } : { startDate? : string , endDate? : string }) => {
      const orderstartDateStr = startDate  ? ` AND DATE(orders.date) >= '${moment(startDate).format("YYYY-MM-DD")}' `  : "";
      const orderendDateStr = endDate  ? ` AND DATE(orders.date) <= '${moment(endDate).format("YYYY-MM-DD")}' `  : "";
      const usersstartDateStr = startDate  ? ` AND users.date >= '${moment(startDate).format("YYYY-MM-DD")}' `  : "";
      const usersendDateStr = endDate  ? ` AND users.date <= '${moment(endDate).format("YYYY-MM-DD")}' `  : "";
     
     
  
      let usersNumberChartQuery = `SELECT COUNT(id) as data, DATE(date) as label FROM users WHERE 1=1  ${usersstartDateStr} ${usersendDateStr}   GROUP BY DATE(date)  `;
      const usersByDate = await execute(usersNumberChartQuery) as DataRow[];
  
      let usersOrdersNumberQuery = `SELECT users.first_name , users.last_name as label , users.id, COUNT(orders.user_id) AS data FROM users JOIN orders ON users.id = orders.user_id WHERE 1=1 ${usersstartDateStr} ${usersendDateStr}  GROUP BY orders.user_id ORDER BY data DESC  `;
      const usersOrdersNumber = await execute(usersOrdersNumberQuery)as DataRow[];
  
      let activeUsersQuery = `SELECT users.id , users.first_name , users.last_name, users.profile_pic , COUNT(orders.user_id) AS order_count FROM users JOIN orders ON users.id = orders.user_id  WHERE 1=1 ${orderstartDateStr} ${orderendDateStr}  GROUP BY orders.user_id ORDER BY order_count DESC LIMIT 5`;
      const activeUsers = await execute(activeUsersQuery);

      const stats = {
        usersByDate,
        usersOrdersNumber,
        activeUsers
      };

      return stats  
    },


    getConflictsStats  : async ( { startDate , endDate } : { startDate? : string , endDate? : string }) => {
      const conflictsstartDateStr = startDate
        ? ` AND DATE(conflicts.date) >= '${moment(startDate).format("YYYY-MM-DD")}' `
        : "";
      const conflictsendDateStr = endDate
        ? ` AND DATE(conflicts.date) <= '${moment(endDate).format("YYYY-MM-DD")}' `
        : "";
  
      let conflictStatusQuery = `SELECT COUNT(conflicts.id) as data ,conflicts.date, conflict_status.name as label  ,  conflict_status.color as status_color FROM conflicts join conflict_status ON conflicts.status = conflict_status.id WHERE 1=1 ${conflictsstartDateStr} ${conflictsendDateStr}  GROUP BY conflicts.status  `;
      const conflictStatus = await execute(conflictStatusQuery)  as DataRow[];
  
      let conflictTypeQuery = `SELECT COUNT(conflicts.id) as data , conflicts.type , conflicts.date as label FROM conflicts WHERE 1=1 ${conflictsstartDateStr} ${conflictsendDateStr}  GROUP BY conflicts.type  `;
      const conflictsType = await execute(conflictTypeQuery) as DataRow[];
  
      let conflictProductQuery = `SELECT p.id AS product_id, p.name AS label, conflicts.date, COUNT(conflicts.id) AS data FROM products p JOIN orders o ON p.id = o.product_id JOIN conflicts  ON o.id = conflicts.order_id WHERE 1=1 ${conflictsstartDateStr} ${conflictsendDateStr}  GROUP BY p.id, p.name; `;
      const conflictsByProduct = await execute(conflictProductQuery) as DataRow[];
      for (const iterator of conflictsByProduct) {
        iterator.label= typeof iterator.label == "string" ? JSON.parse(`${iterator.label}`) : iterator.label
  
      }
      let conflictDateQuery = `SELECT COUNT(conflicts.id) as data , DATE(date)  as label FROM conflicts WHERE 1=1 ${conflictsstartDateStr} ${conflictsendDateStr}  GROUP BY DATE(date)  `;
      const conflictsByDate = await execute(conflictDateQuery) as DataRow[];
  
      const stats = {
        conflictStatus,
        conflictsType,
        conflictsByDate,
        conflictsByProduct
      };

      return stats
  
    },

    getDashboardStats  : async ( { startDate , endDate , is_order_special } : { startDate? : string , endDate? : string , is_order_special? : boolean }) => {
      const orderstartDateStr = startDate  ? ` AND DATE(orders.date) >= '${moment(startDate).format("YYYY-MM-DD")}' `  : "";
      const orderendDateStr = endDate  ? ` AND DATE(orders.date) <= '${moment(endDate).format("YYYY-MM-DD")}' `  : "";
      const specialOrderStr = is_order_special ? ` AND orders.is_special=1`: ""
  
      let bestSellersQuery = `SELECT products.name  as label, products.id ,  products.images, COUNT(orders.product_id) AS data FROM products JOIN orders ON products.id = orders.product_id WHERE products.is_deleted = 0  ${specialOrderStr}   ${orderstartDateStr} ${orderendDateStr} GROUP BY orders.product_id ORDER BY data DESC LIMIT 5`;
      const bestSellers = (await execute(bestSellersQuery)) as (Product & {label : string  , data : number})[] ;
      for (const bestSeller of bestSellers as (Product & {label : string })[]) {        
        bestSeller.label= typeof bestSeller.label == "string" ? JSON.parse(`${bestSeller.label}`) : bestSeller.label
        bestSeller.images = typeof bestSeller.images== 'string' ?JSON.parse(`${bestSeller.images}`) : bestSeller.images
      }

      let activeUsersQuery = `SELECT users.id , users.first_name , users.last_name, users.profile_pic , COUNT(orders.user_id) AS order_count FROM users JOIN orders ON users.id = orders.user_id  WHERE 1=1 ${orderstartDateStr} ${orderendDateStr}  GROUP BY orders.user_id ORDER BY order_count DESC LIMIT 5`;
      const activeUsers = await execute(activeUsersQuery) as User[];

      return {
        bestSellers,
        activeUsers
      }

    },


    getProductStats  : async ( { startDate , endDate , is_order_special } : { startDate? : string , endDate? : string , is_order_special? : boolean }) => {
      const productsstartDateStr = startDate ? ` AND DATE(products.date) >= '${moment(startDate).format("YYYY-MM-DD")}' ` : "";
      const productsendDateStr = endDate  ? ` AND DATE(products.date) <= '${moment(endDate).format("YYYY-MM-DD")}' `  : "";
      const orderstartDateStr = startDate  ? ` AND DATE(orders.date) >= '${moment(startDate).format("YYYY-MM-DD")}' `  : "";
      const orderendDateStr = endDate  ? ` AND DATE(orders.date) <= '${moment(endDate).format("YYYY-MM-DD")}' `  : "";
      const specialOrderStr = is_order_special ? ` AND orders.is_special=1`: ""
      
  
      let bestSellersQuery = `SELECT products.name  as label, products.id ,  products.images, COUNT(orders.product_id) AS data FROM products JOIN orders ON products.id = orders.product_id WHERE products.is_deleted = 0  ${specialOrderStr}   ${orderstartDateStr} ${orderendDateStr} GROUP BY orders.product_id ORDER BY data DESC LIMIT 5`;
      const bestSellers = (await execute(bestSellersQuery)) as (Product & {label : string })[] | DataRow[];
      for (const bestSeller of bestSellers as (Product & {label : string })[]) {
        bestSeller.label= typeof bestSeller.label == "string" ? JSON.parse(`${bestSeller.label}`) : bestSeller.label
        bestSeller.images = typeof bestSeller.images== 'string' ?JSON.parse(`${bestSeller.images}`) : bestSeller.images
        
      }   
  
      const productBysubCategoryQuery = `SELECT sc.id AS sub_category_id, sc.name AS label, COUNT(products.id) AS data FROM products JOIN sub_categories sc ON products.sub_category_id = sc.id WHERE products.is_deleted = 0  ${productsstartDateStr} ${productsstartDateStr} GROUP BY   sc.id ORDER BY data DESC;`;
      const productBysubCategory = (await execute(productBysubCategoryQuery))as DataRow[];            
      for (const iterator of productBysubCategory) {
        iterator.label= typeof iterator.label == "string" ? JSON.parse(`${iterator.label}`) : iterator.label
  
      }            
      const productByCategoryQuery = `SELECT c.id AS category_id, c.name AS label, COUNT(products.id) AS data FROM products JOIN categories c ON products.category_id = c.id  WHERE products.is_deleted = 0 ${productsstartDateStr} ${productsendDateStr}  GROUP BY c.id  ORDER BY data DESC;`;
      const productByCategory = (await execute(productByCategoryQuery))as DataRow[];            
      for (const p of productByCategory) {
        p.label= typeof p.label == "string" ? JSON.parse(`${p.label}`) : p.label
  
      }
      const productBysuperCategoryQuery = `SELECT scat.id AS super_category_id, scat.name AS label, COUNT(products.id) AS data FROM products  JOIN super_categories scat ON products.super_category_id = scat.id WHERE products.is_deleted = 0  ${productsstartDateStr} ${productsendDateStr}  GROUP BY scat.id ORDER BY data DESC;    `;
      const productBysuperCategory = (await execute(productBysuperCategoryQuery))as DataRow[];            
      for (const p of productBysuperCategory) {
        p.label= typeof p.label == "string" ? JSON.parse(`${p.label}`) : p.label
  
      }
      const stats = {
        bestSellers,
        productBysubCategory,
        productByCategory ,
        productBysuperCategory
      };  
      return stats
    }
}


export default stats